import type { DataItem } from '@pn/core/domain/data';
import type { IntelWorkspaceItem } from '@pn/core/domain/intel/intel-workspace-item';
import { exportWorkspaceItem } from '@pn/core/operations/workspace';
import { apiIntelDynamicDataProvider } from '@pn/services/api/intel-data/apiIntelDataProvider';
import { isString } from 'lodash-es';

/**
 * Fetches an intel item's data. Crown mineral activity has no intel endpoint,
 * so it goes through the regular workspace export instead, with each row
 * linked to itself as its own activity item.
 */
export async function getIntelItemData(params: {
  intelWorkspaceItem: IntelWorkspaceItem;
  geometry?: GeoJSON.Geometry;
  province?: string;
}): Promise<DataItem[]> {
  const { intelWorkspaceItem, geometry } = params;

  if (intelWorkspaceItem.query.dataType !== 'crown_mineral_activity') {
    return apiIntelDynamicDataProvider.getData(params);
  }

  const { data } = await exportWorkspaceItem({
    item: intelWorkspaceItem,
    fields: intelWorkspaceItem.query.fields,
    silent: true,
    geometry,
  });

  return data.map((dataItem) => {
    const id = dataItem['internal_id'];
    if (isString(id)) dataItem.activityItemIds = [id];
    return dataItem;
  });
}
